[
  {
    "code": "84",
    "departements": ["01", "03", "07", "15", "26", "38", "42", "43", "63", "69", "73", "74"],
    "nom": "Auvergne-Rhône-Alpes",
    "slug": "auvergne-rhone-alpes",
    "zoom": 8,
    "localisation": {
      "longitude": 4.538056,
      "latitude": 45.515833
    }
  },
  {
    "code": "27",
    "nom": "Bourgogne-Franche-Comté",
    "slug": "bourgogne-franche-comte",
    "departements": ["21", "25", "39", "58", "70", "71", "89", "90"],
    "zoom": 8,
    "localisation": {
      "longitude": 4.809167,
      "latitude": 47.235278
    }
  },
  {
    "code": "53",
    "nom": "Bretagne",
    "slug": "bretagne",
    "departements": ["22", "29", "35", "56"],
    "zoom": 8,
    "localisation": {
      "longitude": -2.838611,
      "latitude": 48.179722
    }
  },
  {
    "code": "24",
    "nom": "Centre-Val de Loire",
    "slug": "centre-val-de-loire",
    "departements": ["18", "28", "36", "37", "41", "45"],
    "zoom": 8,
    "localisation": {
      "longitude": 1.685278,
      "latitude": 47.480556
    }
  },
  {
    "code": "94",
    "nom": "Corse",
    "slug": "corse",
    "departements": ["2A", "2B"],
    "zoom": 8,
    "localisation": {
      "longitude": 9.105278,
      "latitude": 42.149722
    }
  },
  {
    "code": "44",
    "nom": "Grand Est",
    "slug": "grand-est",
    "departements": ["08", "10", "51", "52", "54", "55", "57", "67", "68", "88"],
    "zoom": 8,
    "localisation": {
      "longitude": 5.619444,
      "latitude": 48.689167
    }
  },
  {
    "code": "01",
    "nom": "Guadeloupe",
    "slug": "guadeloupe",
    "departements": ["971"],
    "zoom": 9,
    "localisation": {
      "longitude": -61.551,
      "latitude": 16.2
    }
  },
  {
    "code": "03",
    "nom": "Guyane",
    "slug": "guyane",
    "departements": ["973"],
    "zoom": 7.5,
    "localisation": {
      "longitude": -52.5,
      "latitude": 4
    }
  },
  {
    "code": "32",
    "departements": ["02", "59", "60", "62", "80"],
    "nom": "Hauts-de-France",
    "slug": "hauts-de-france",
    "zoom": 8,
    "localisation": {
      "longitude": 2.775278,
      "latitude": 49.966111
    }
  },
  {
    "code": "11",
    "nom": "Île-de-France",
    "slug": "ile-de-france",
    "departements": ["75", "77", "78", "91", "92", "93", "94", "95"],
    "zoom": 8.9,
    "localisation": {
      "longitude": 2.504722,
      "latitude": 48.709167
    }
  },
  {
    "code": "04",
    "nom": "La Réunion",
    "slug": "la-reunion",
    "departements": ["974"],
    "zoom": 9,
    "localisation": {
      "longitude": 55.536384,
      "latitude": -21.115141
    }
  },
  {
    "code": "02",
    "nom": "Martinique",
    "slug": "martinique",
    "departements": ["972"],
    "zoom": 9,
    "localisation": {
      "longitude": -61.024174,
      "latitude": 14.641528
    }
  },
  {
    "code": "06",
    "nom": "Mayotte",
    "slug": "mayotte",
    "departements": ["976"],
    "zoom": 9,
    "localisation": {
      "longitude": 45.166244,
      "latitude": -12.8275
    }
  },
  {
    "code": "28",
    "nom": "Normandie",
    "slug": "normandie",
    "departements": ["14", "27", "50", "61", "76"],
    "zoom": 8.2,
    "localisation": {
      "longitude": 0.106667,
      "latitude": 49.121111
    }
  },
  {
    "code": "75",
    "nom": "Nouvelle-Aquitaine",
    "slug": "nouvelle-aquitaine",
    "departements": ["16", "17", "19", "23", "24", "33", "40", "47", "64", "79", "86", "87"],
    "zoom": 7.1,
    "localisation": {
      "longitude": 0.197778,
      "latitude": 45.192222
    }
  },
  {
    "code": "76",
    "nom": "Occitanie",
    "slug": "occitanie",
    "departements": ["09", "11", "12", "30", "31", "32", "34", "46", "48", "65", "66", "81", "82"],
    "zoom": 8,
    "localisation": {
      "longitude": 2.137222,
      "latitude": 43.702222
    }
  },
  {
    "code": "52",
    "nom": "Pays de la Loire",
    "slug": "pays-de-la-loire",
    "departements": ["44", "49", "53", "72", "85"],
    "zoom": 8.2,
    "localisation": {
      "longitude": -0.823888,
      "latitude": 47.474722
    }
  },
  {
    "code": "93",
    "departements": ["04", "05", "06", "13", "83", "84"],
    "nom": "Provence-Alpes-Côte d'Azur",
    "slug": "provence-alpes-cote-dazur",
    "zoom": 8.5,
    "localisation": {
      "longitude": 6.053333,
      "latitude": 43.955
    }
  },
  {
    "code": "00",
    "nom": "Saint Martin",
    "slug": "saint-martin",
    "departements": ["978"],
    "zoom": 9,
    "localisation": {
      "longitude": -63.0667,
      "latitude": 18.0667
    }
  }
]
